'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeatureFlags = undefined;

var _middleware = require('../../middleware');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

var getFeatureFlags = exports.getFeatureFlags = function getFeatureFlags() {
  return function (dispatch) {
    return dispatch(_defineProperty({}, _middleware.CALL_API, {
      config: {
        url: IFEIS_API_URI + '/api/feature-flags',
        method: 'GET'
      },
      types: ['GET_FEATURE_FLAGS_START', 'GET_FEATURE_FLAGS', 'GET_FEATURE_FLAGS_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/feature-flags/getFeatureFlags.js
// module id = 61
// module chunks = 0